export const searchPokemon = async (pokemon) => {
    try {
      let url = `https://pokeapi.co/api/v2/pokemon/${pokemon}`;
      const response = await fetch(url);
      const data = await response.json();
      return data;
    } catch (err) {}
  };

  //recoge un numero maximo de pokemons y define desde cual pokemon inicia la renderización
  export const getPokemons = async (limit = 9, offset = 0) => {
    try {
      let url = `https://pokeapi.co/api/v2/pokemon?limit=${limit}&offset=${offset}`;
      const response = await fetch(url);
      const data = await response.json();
      return data;
    } catch (err) {}
  };

  //recoge la información del pokemon requerido y la entrega
  export const getPokemonData = async (url) =>{
    try{
      const response = await fetch(url);
      const data = await response.json();
      return data;
  } catch (err) {

  }}